var React = require('react');

function ContentMountainTrail (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-mountain-trail"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("path",{"d":"M85.27,64.35,42.58,10.92c-.69-.86-1.91-.39-2.44.32L.3,64.66C-.89,66.26,1.79,67.81,3,66.23L41.52,14.54l7,8.81c-4.14,1.11-8.37,3.37-9.79,7.56-1.71,5.07,1.75,11,4.83,14.77,2.55,3.13,7.56,7.47,3.58,11.61-3.52,3.66-9.3,2.63-13.83,3.05-5,.47-9.72,2.59-11.32,7.65-.6,1.91,2.39,2.72,3,.83,3.46-11,26-.08,26.84-14.63.3-5.24-4.88-8.67-7.44-12.58-1.85-2.82-4.1-7.16-2.35-10.54,1.58-3,5.41-4.38,8.62-5.05L83.08,66.54C84.32,68.1,86.5,65.89,85.27,64.35Z","key":0}),React.createElement("circle",{"cx":"14.77","cy":"8.28","r":"8.28","key":1})]))]);
}

ContentMountainTrail.defaultProps = {"viewBox":"0 0 85.64 69.89"};

module.exports = ContentMountainTrail;

ContentMountainTrail.default = ContentMountainTrail;
